var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-calendar is-flex"},[_c('div',{staticClass:"full-calendar-main"},[_c('FullCalendar',{ref:"fullCalendar",staticClass:"full-calendar-calendar",attrs:{"options":_vm.innerCalendarOptions}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }